module.exports = __webpack_public_path__ + "static/media/styledmenu-close-white.07dae301.svg";